"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Provide a strong-typed version of Object.keys()
 * @param obj The source object
 * @returns Array of keys
 */
function getObjectKeys(obj) {
    return Object.keys(obj);
}
exports.default = getObjectKeys;
//# sourceMappingURL=getObjectKeys.js.map